/** Écran de repli : une adresse qui ne correspond à aucun écran du back-office. */
import { Link } from 'react-router-dom';

import { M } from '../catalogue/messages';

export function EcranIntrouvable() {
  return (
    <div className="ecran-simple">
      <h1 className="entete-ecran__titre">{M.introuvable.titre}</h1>
      <p className="entete-ecran__sous-titre">{M.introuvable.corps}</p>
      <Link className="lien-action" to="/cartes">
        {M.introuvable.retour}
      </Link>
    </div>
  );
}
